import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { usePartnerRepStatus } from "../hooks/useApi";

const mainTabs = [
  {
    to: "/dashboard",
    label: "داشبورد",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
      </svg>
    ),
  },
  {
    to: "/wallet",
    label: "کیف پول",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 7V4a1 1 0 00-1-1H5a2 2 0 000 4h15a1 1 0 011 1v4" />
        <path d="M3 19V5a2 2 0 012-2h14a1 1 0 011 1v2" />
        <rect x="3" y="11" width="18" height="10" rx="2" />
        <circle cx="17" cy="16" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    to: "/usage",
    label: "مصرف",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
  {
    to: "/api-keys",
    label: "کلیدها",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
      </svg>
    ),
  },
];

const moreItems = [
  {
    to: "/logs",
    label: "لاگ‌ها",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    to: "/partners/dashboard",
    label: "همکاران",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="m11 17 2 2a1 1 0 1 0 3-3" />
        <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
        <path d="m21 3 1 11h-2" />
        <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
        <path d="M3 4h8" />
      </svg>
    ),
  },
  {
    to: "/models",
    label: "مدل‌ها",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a10 10 0 1010 10" />
        <path d="M12 12l3-3" />
        <circle cx="12" cy="12" r="2" />
        <path d="M21 2l-4 4" />
        <path d="M21 2h-4" />
        <path d="M21 6V2" />
      </svg>
    ),
  },
  {
    to: "/profile",
    label: "پروفایل",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21v-1a8 8 0 0116 0v1" />
      </svg>
    ),
  },
  {
    to: "/subscription",
    label: "اشتراک",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 3h12l4 6-10 13L2 9z" />
        <path d="M11 3L8 9l4 13 4-13-3-6" />
        <path d="M2 9h20" />
      </svg>
    ),
  },
  {
    to: "/support",
    label: "پشتیبانی",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 14v-3a9 9 0 0118 0v3" />
        <path d="M21 14h-3a2 2 0 00-2 2v3a2 2 0 002 2h1a2 2 0 002-2v-5z" />
        <path d="M3 14h3a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-5z" />
      </svg>
    ),
  },
  {
    to: "/docs",
    label: "مستندات",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
      </svg>
    ),
  },
];

export default function MobileFooterNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { data: repStatus } = usePartnerRepStatus();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const visibleMore = repStatus?.is_representative
    ? moreItems
    : moreItems.filter((item) => item.to !== "/partners/dashboard");
  const centerActive = visibleMore.some((item) => pathname === item.to);

  return (
    <>
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 pointer-events-none">
        <div className="max-w-[360px] mx-auto mb-2 px-3">
          <div className="flex items-center justify-around bg-surface rounded-[24px] px-4 py-2 shadow-card pointer-events-auto">
            {mainTabs.slice(0, 2).map((item) => (
              <TabLink key={item.to} item={item} />
            ))}

            {/* Center action */}
            <button
              type="button"
              onClick={() => setOpen(true)}
              aria-label="بیشتر"
              className={`flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-colors ${
                centerActive ? "text-primary" : "text-text-tertiary"
              }`}
            >
              <span
                className={`w-14 h-14 -mt-6 rounded-full bg-primary text-white flex items-center justify-center shadow-card transition-transform active:scale-95 ${
                  centerActive ? "ring-4 ring-primary-light" : ""
                }`}
              >
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <path d="M12 5v14M5 12h14" />
                </svg>
              </span>
              <span className="text-[11px] mt-0.5">بیشتر</span>
            </button>

            {mainTabs.slice(2).map((item) => (
              <TabLink key={item.to} item={item} />
            ))}
          </div>
        </div>
      </nav>

      {/* More bottom sheet */}
      {open && (
        <div className="fixed inset-0 z-50 md:hidden" onClick={() => setOpen(false)}>
          <div className="absolute inset-0 bg-black/20 backdrop-blur-sm animate-fade-in" />
          <div
            className="glass absolute bottom-0 inset-x-0 rounded-t-[20px] p-5 pb-8 animate-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-10 h-1 rounded-full bg-line mx-auto mb-5" />
            <h2 className="text-h3 font-semibold text-text-main mb-4">بیشتر</h2>
            <div className="grid grid-cols-3 gap-2">
              {visibleMore.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={`flex flex-col items-center gap-2 p-3 rounded-card transition-colors ${
                    pathname === item.to ? "bg-primary-light text-primary" : "text-text-main hover:bg-surface-hover"
                  }`}
                >
                  <span className={pathname === item.to ? "text-primary" : "text-text-secondary"}>{item.icon}</span>
                  <span className="text-small">{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function TabLink({ item }: { item: { to: string; label: string; icon: React.ReactNode } }) {
  return (
    <NavLink
      to={item.to}
      className={({ isActive }) =>
        `flex flex-col items-center gap-1 py-1 px-3 rounded-lg transition-colors ${
          isActive ? "text-primary" : "text-text-tertiary hover:text-text-secondary"
        }`
      }
    >
      {item.icon}
      <span className="text-[11px]">{item.label}</span>
    </NavLink>
  );
}
